export default "__VITE_ASSET__BLnpHGP2__"